/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from "react"
import Grid from "../../../../../../components/Habitacional/core/Grid"
import * as S from "../FormMIP.Style"
import CPFInput from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/CPFInput"
import CheckBoxCombo from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/CheckBoxCombo"
import IncidentDateInput from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/IncidentDateInput"
import EmailInput from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/EmailInput"
import PhoneNumberInput from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/PhoneNumberInput"
import SelectFeedBackInput from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/SelectFeedBackInput"
import MessageInput from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/MessageInput"
import Button from "../../../../../../components/Habitacional/core/Button"
import { handleScrollSmooth } from "../../../../../../components/Habitacional/CardActivateInsurance/CardActivateInsurance"
import SelectCauseIncidentInputMIPInsured from "../../../../../../components/Habitacional/core/Form/InputCompleteForm/SelectCauseIncidentInputMIPInsured"


const FormStepOneInsuredMIP = ({ isLoading }) => {
    return (
        <S.ContentFormMIP>
            <Grid container spacingColumn={7.5} spacingRow={3}>
                <Grid item md={6} lg={6} xl={6}>
                    <CPFInput />
                </Grid>
                <Grid item md={6} lg={6} xl={6}>
                    <IncidentDateInput />
                </Grid>
                <Grid item md={6} lg={6} xl={6}>
                    <SelectCauseIncidentInputMIPInsured />
                </Grid>
                <Grid item md={6} lg={6} xl={6}>
                    <EmailInput />
                </Grid>
                <Grid item md={6} lg={6} xl={6}>
                    <PhoneNumberInput />
                </Grid>
                <Grid item md={6} lg={6} xl={6}>
                    <SelectFeedBackInput />
                </Grid>
            </Grid>
            <MessageInput />
            <S.TextError>* Campos obrigatórios</S.TextError>
            <CheckBoxCombo />
            <S.ContentButton>
                <Button variant="primary" type="submit" onClick={() => {handleScrollSmooth()}} disabled={isLoading}>Seguir</Button>
            </S.ContentButton>
        </S.ContentFormMIP>
    )
}

export default FormStepOneInsuredMIP